import { handleRetrieveBlogCategories } from "../../../../../redux/public-slices/blog.slice";
import SkeletonImage from "../../../../../components/ui/SkeletonImage";
import { webinarBasicsSchema } from "../../../../../utils/velidations";
import InputFieldB from "../../../../../components/ui/InputFieldB";
import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Icons from "../../../../../assets/js/Icons";

import {
  Box, Button, Checkbox, CircularProgress, FormControlLabel,
  FormGroup, Icon, InputLabel, Stack, Typography,
} from "@mui/material";

function BasicDetail({ data, setValue }) {
  const files = useRef("");
  const dispatch = useDispatch();

  const [image, setImage] = useState(null);
  const [helperText, setHelperText] = useState([]);
  const { specialist } = useSelector((state) => state.authSlice);
  const { loadings } = useSelector((state) => state.otherSlice);
  const [audiences, setAudiences] = useState(
    data?.details?.targetAudience || []
  );

  const handleImagePreview = (e) => {
    files.current = Array.from(e.target.files);
    const views = files.current?.map((img) => URL.createObjectURL(img));
    setImage(views);
  };
  const handleretrieveAll = async () => {
    await dispatch(
      handleRetrieveBlogCategories({ limit: 100 })
    ).unwrap();
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const formData = Object.fromEntries(form);
    formData.coverImage = data?.details?.coverImage || files?.current || null;
    formData.targetAudience = audiences;

    const rawSeats =
      formData?.numberOfSeats !== undefined && formData?.numberOfSeats !== ""
        ? formData.numberOfSeats
        : data?.details?.numberOfSeats;
    formData.numberOfSeats = parseInt(rawSeats || 0, 10);
    const result = webinarBasicsSchema.safeParse(formData);
    if (!result.success) {
      const groupedErrors = {};
      result.error.issues.forEach((issue) => {
        const key = issue.path[0];
        if (!groupedErrors[key]) {
          groupedErrors[key] = [];
        }
        groupedErrors[key].push(issue.message);
      });
      setHelperText(groupedErrors);
      return;
    }
    setHelperText([]);
    data.details = formData;
    setValue("schedule");
  };
  const handleAudienceChange = (value, checked) => {
    if (checked) {
      setAudiences([...audiences, value]);
    } else {
      setAudiences(audiences.filter((a) => a !== value));
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setAudiences(["individuals", "couples", "parents", "teens"]);
    } else {
      setAudiences([]);
    }
  };

  useEffect(() => {
    if (data?.details?.coverImage) {
      const views = data?.details?.coverImage?.map((img) =>
        URL.createObjectURL(img)
      );
      setImage(views);
    }
    handleretrieveAll();
    // eslint-disable-next-line
  }, []);
  return (
    <Fragment>
      <Typography>
        Help our community grow and heal — lead a meaningful session through
        your upcoming webinar. Share your session details and we’ll take care of
        the rest!
      </Typography>

      <Typography variant="typographyA">Webinar Basics</Typography>
      <Stack spacing={2} component="form" onSubmit={handleSubmit}>
        <InputFieldB
          name="title"
          label="Title *"
          variant="outlined"
          helperText={helperText}
          placeholder="Enter Title"
          defaultValue={data?.details?.title || ""}
          inputProps={{ maxLength: 100 }}
        />
        <Box>
          <InputLabel
            sx={{
              mb: 0,
              height: "100%",
              maxHeight: 300,
              borderRadius: "8px",
              border: "1px dashed",
              placeContent: "center",
              borderColor: "primary.main",
              display: image ? "block" : "grid",
            }}
          >
            {image ? (
              <SkeletonImage
                sx={{ objectFit: "contain", height: "43vh" }}
                src={image || null}
              />
            ) : (
              <>
                <Icon
                  sx={{
                    fontSize: "100px",
                    color: "other.color2",
                    m: "auto",
                    svg: { display: "block" },
                  }}
                >
                  <Icons.ImageSolid />
                </Icon>
                <Typography mb={1.5} color="other.color2">
                  Upload cover image
                </Typography>
              </>
            )}
            <input
              style={{ display: "none" }}
              onChange={handleImagePreview}
              accept="image/*"
              type="file"
            />
            {/*  */}
          </InputLabel>
          {helperText?.coverImage?.[0] && (
            <Typography mt={0.5} fontSize="14px" color="error.main">
              {helperText?.coverImage?.[0]}
            </Typography>
          )}
        </Box>

        <InputFieldB
          type="textarea"
          name="description"
          variant="outlined"
          label="Description *"
          helperText={helperText}
          placeholder="Enter description"
          defaultValue={data?.details?.description || ""}
        />

        <InputFieldB
          disabled
          variant="outlined"
          label="Specialist name *"
          placeholder="Enter your specialist name"
          defaultValue={specialist?.specialist?.fullName}
        />
        {/* <SelectInput
         fontWeight={400}

              label="Category *"
              renderValueKey="name"
              inputRef={categoryRef}
              placeholder="Enter Question"
              selectLabel="Select Category"
              // loading={loadings?.retrieveAll}
              options={categories || []}
            /> */}
        <Box>
          <InputLabel labelvariant="InputFieldB">Taget audience</InputLabel>
          <FormGroup row>
            <FormControlLabel
              label="Individuals"
              control={
                <Checkbox
                  checked={audiences.includes("individuals")}
                  onChange={(e) =>
                    handleAudienceChange("individuals", e.target.checked)
                  }
                />
              }
            />

            <FormControlLabel
              label="Couples"
              control={
                <Checkbox
                  checked={audiences.includes("couples")}
                  onChange={(e) =>
                    handleAudienceChange("couples", e.target.checked)
                  }
                />
              }
            />

            <FormControlLabel
              label="Parents"
              control={
                <Checkbox
                  checked={audiences.includes("parents")}
                  onChange={(e) =>
                    handleAudienceChange("parents", e.target.checked)
                  }
                />
              }
            />

            <FormControlLabel
              label="Teens"
              control={
                <Checkbox
                  checked={audiences.includes("teens")}
                  onChange={(e) =>
                    handleAudienceChange("teens", e.target.checked)
                  }
                />
              }
            />

            <FormControlLabel
              label="All"
              control={
                <Checkbox
                  checked={audiences.length === 4} // all selected
                  onChange={(e) => handleSelectAll(e.target.checked)}
                />
              }
            />

            {/* <FormControlLabel
              label="Individuals"
              value="individuals"
              name="targetAudience"
              control={<Checkbox defaultChecked={Boolean(data?.details?.targetAudience?.includes("individuals"))} />}
            />
            <FormControlLabel
              label="Couples"
              value="couples"
              name="targetAudience"
              control={<Checkbox defaultChecked={Boolean(data?.details?.targetAudience?.includes("couples"))} />}
            />
            <FormControlLabel
              label="Parents"
              value="parents"
              name="targetAudience"
              control={<Checkbox defaultChecked={Boolean(data?.details?.targetAudience?.includes("parents"))} />}
            />
            <FormControlLabel
              label="Teens"
              value="teens"
              name="targetAudience"
              control={<Checkbox defaultChecked={Boolean(data?.details?.targetAudience?.includes("teens"))} />}
            />
            <FormControlLabel
              label="All"
              value="all"
              name="targetAudience"
              control={<Checkbox defaultChecked={Boolean(data?.details?.targetAudience?.includes("all"))} />}
            /> */}
          </FormGroup>
          {helperText?.targetAudience && (
            <Typography mt={0.5} fontSize="14px" color="error.main">
              {helperText?.targetAudience}
            </Typography>
          )}
        </Box>
        <InputFieldB
          type="number"
          variant="outlined"
          name="numberOfSeats"
          helperText={helperText}
          label="Number of seats *"
          placeholder="Enter number of seats"
          defaultValue={data?.details?.numberOfSeats || ""}
        />
        <Stack direction="row" spacing={1}>
          <Button
            size="large"
            type="submit"
            variant="contained"
            sx={{ minWidth: 150 }}
            disabled={loadings?.create}
            endIcon={
              loadings?.create && (
                <CircularProgress size={20} color="text" thickness={5} />
              )
            }
          >
            Next
          </Button>
        </Stack>
      </Stack>
    </Fragment>
  );
}

export default BasicDetail;
